<template>
<div class="surveillance-survey-list">
  <div class="row">
    <div class="col-xs-12">
      <h1 class="text-primary">
        <small>Programme National {{year}}</small>
        <br>
        Sondages
      </h1>
      <hr>
    </div>
  </div>
  <div v-if="users.length > 0">
    <sui-table :columns="sc.table.columns"
              :actions="sc.table.actions"
              :keyfield="sc.table.keyfield"
              :initial-sort="{ field: 'date', ascend: false }"
              :list="listWithNames"
              title="Sondage SPIADI 2019"
              :filterVariables="variables"
              :filter="filter"
              :filterGen="sc.filters"
              ref="table"
              @comment="comment"
              @evolution="evolution"
              @detail="userDetail">
      <template slot="actions">
        <div class="form-group">
          <btn type="info" @click="exportList">
            Export csv
          </btn>
          <save-blob :target="csv.target"></save-blob>
        </div>
      </template>
    </sui-table>

    <sui-table :columns="sc.table.columns"
              :actions="[]"
              :keyfield="sc.table.keyfield"
              :list="stats"
              title="Stats SPIADI 2019"
              :show-filter="false" />

    <user-modal :user="target" storePrefix="user" v-model="triggerDetail">
    </user-modal>
  </div>
  <div v-else>
    Chargement...
  </div>
</div>
</template>

<script>
import { mapState } from 'vuex'
import sc from '@/views/surveillance/sc/surveys'
import stringify from 'csv-stringify'

import suiTable from '@/sui/components/table'
import userModal from '@/components/usermodal'
import saveBlob from '@/sui/components/saveblob'

export default {
  name: 'surveillance-surveys',

  created () {
    this.$store.dispatch('surveillances/allSurveys')
    if (this.users.length === 0) {
      this.$store.dispatch('user/all')
    }
  },

  data () {
    return {
      variables: [
        { key: 'u', field: 'userid', name: `ID de l'utilisateur` },
        { key: 'n', field: 'username', name: ' Nom' },
        { key: 'c', field: 'comment', name: 'Commentaire' },
        { key: 'e', field: 'evolution', name: 'Évolution' },
        { key: 'o', field: 'overall', name: 'Note globale' },
        { key: 'acc', field: 'account', name: 'Note création de compte' },
        { key: 'ergo', field: 'ergo', name: 'Note ergonomie' },
        { key: 'doc', field: 'documents', name: 'Note documents' },
        { key: 'prot', field: 'protocols', name: 'Note protocoles' },
        { key: 'fich', field: 'sheets', name: 'Note fiches' },
        { key: 'etab', field: 'etab', name: 'Note fiche établissement' },
        { key: 'clot', field: 'valid', name: 'Note clôture' },
        { key: 'cvt', field: 'convention', name: 'Note conventione' },
        { key: 'tel', field: 'contact', name: 'Note contact' },
        { key: 'com', field: 'com', name: 'Note communication' }
      ],
      filter: '',
      statFilter: '',
      surveillance: null,
      sc: sc,
      target: null,
      triggerDetail: false,
      csv: {
        target: null
      }
    }
  },

  computed: {

    ...mapState({
      surveys: state => state.surveillances.surveys,
      users: state => state.user.all
    }),

    year: function () {
      return this.$route.params.year
    },

    stats: function () {
      const columns = [
        'overall',
        'account',
        'ergo',
        'documents',
        'protocols',
        'sheets',
        'etab',
        'valid',
        'convention',
        'contact',
        'com'
      ]
      const values = {}
      columns.forEach(
        c => { values[c] = [] }
      )
      const reducer = (result, s) => {
        columns.forEach(
          c => {
            const value = s[c]
            if (value != null) {
              result[c].push(value)
            }
          }
        )
        return result
      }
      this.surveys.reduce(reducer, values)
      const mean = {
        username: 'Moyenne'
      }
      const median = {
        username: 'Mediane'
      }
      columns.forEach(
        c => {
          let sum = 0
          values[c].forEach(
            v => {
              sum += v
            }
          )
          values[c] = values[c].sort((f, s) => f - s)
          const count = values[c].length
          if (count > 0) {
            mean[c] = (sum / count).toFixed(2)
            const index = Math.floor((count - 1) / 2.0)
            median[c] = values[c][Math.floor(index)].toFixed(2)
          }
        }
      )

      return [mean, median]
    },

    listWithNames: function () {
      const reducer = (result, s) => {
        const user = this.users.find(u => u.id === s.userid)
        const line = Object.assign({}, s)
        line.username = user != null ? `${user.firstName} ${user.name}` : `Utilisateur supprimé`
        line.user = user != null ? user : ''
        return result
      }
      return this.surveys.reduce(reducer, [])
    }
  },

  methods: {
    comment: function (s) {
      this.$alert({
        title: 'Commentaire',
        content: s.comment.replace(/\n/g, '<br />'),
        html: true
      })
    },

    evolution: function (s) {
      this.$alert({
        title: 'Évolution',
        content: s.evolution.replace(/\n/g, '<br />'),
        html: true
      })
    },

    userDetail: function (u) {
      this.target = u.user
      this.triggerDetail = true
    },

    exportList: function () {
      const vm = this
      stringify(
        this.$refs.table.formattedList,
        {
          bom: true,
          header: true,
          delimiter: ';',
          cast: {
            boolean: function (b) {
              return { value: b ? 'Oui' : 'Non', quote: false }
            }
          },
          columns: sc.columns
        },

        function (err, output) {
          if (err != null) {
            vm.$notify({
              type: 'danger',
              title: 'Erreur !',
              content: `Impossible d'exporter les données: ${err}.`
            })
          } else {
            setTimeout(
              function () {
                vm.csv.target = {
                  filename: `bo-export-surveys.csv`,
                  blob: new Blob([output], { type: 'text/plain' })
                }
              }, 10)
          }
        })
    }
  },

  components: {
    'user-modal': userModal,
    'sui-table': suiTable,
    'save-blob': saveBlob
  }
}
</script>
<style lang="less" scoped>
</style>
